import { useTranslation } from '@dreamstack/i18n'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { Text_13_18, Text_16_24 } from '../layout/Texts'

export type EquipmentFeature = {
  key: string
  value: any
  label: string | null
}

export const EquipmentFeatures: FunctionComponent<React.PropsWithChildren<{
  equipment: EquipmentFeature[]
}>> = ({ equipment }) => {
  const t = useTranslation()
  return (
    <div className="block w-screen box-border md:flex lg:flex">
      <div className="justify-center items-center font-semibold text-xl pt-8 md:pt-12">
        <Text_16_24>{t('accentro:equipment')}</Text_16_24>
      </div>
      <div className="flex mr-px-96 pt-px-16 flex-wrap md:pt-8 md:pr-10 md:pl-px-20">
        {map(equipment, (e) => (
          <div
            key={e.key}
            className="bg-accentroAquaVeryLight-full mt-2 mr-2 p-3 md:ml-px-4 md:px-4"
          >
            <Text_13_18>{e.label}</Text_13_18>
          </div>
        ))}
      </div>
    </div>
  )
}
